import { UploadOutlined } from '@ant-design/icons'
import { UploadFile } from 'antd/es/upload/interface'
import type { RcFile } from 'antd/lib/upload/interface'
import { useCallback, useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { Button, Form, Upload } from '@vivaldis/antd-ui'
import { fileToBase64 } from '../../../../../utils/fileToBase64'
import { transformDataToBase64 } from '../../../../EmployeeCertificateForm/utils/transformDataToBase64'
import { useForm } from '../../../providers/FormProvider'

export const UploadPDFWPSFormContent = () => {
  const [t] = useTranslation('web_ui')

  const [fileList, setFileList] = useState<UploadFile[]>([])

  const { setFieldValue, isSubmitting } = useForm()

  useEffect(() => {
    if (isSubmitting) {
      // we want to simulate a progress bar. We will update the progress bar every 100ms until it reaches 95%
      const intervalId = setInterval(() => {
        setFileList(prevFileList => {
          if (prevFileList.length > 0) {
            return prevFileList.map(file => {
              const percent = (file?.percent ?? 0) + 2
              return {
                ...file,
                percent: Math.min(percent, 95),
                status: 'uploading'
              }
            })
          }
          return prevFileList
        })
      }, 100)

      return () => clearInterval(intervalId)
    }
  }, [isSubmitting])

  const handlePDFUpload = useCallback(
    async (file: RcFile) => {
      try {
        // update UI with a new file
        setFileList([
          {
            uid: file.uid,
            name: file.name
          }
        ])

        const newPdfCommentAttachment = {
          fileName: file.name,
          base64: await fileToBase64(file),
          dataURL: await transformDataToBase64(file)
        }

        setFieldValue('newPdfCommentAttachment', newPdfCommentAttachment)

        return newPdfCommentAttachment.dataURL
      } catch (e) {
        setFileList([])
      }
      return ''
    },
    [setFieldValue]
  )

  return (
    <Form.Item name="newPdfCommentAttachment.base64">
      <Upload
        action={handlePDFUpload}
        fileList={fileList}
        showUploadList={{
          showDownloadIcon: false,
          showRemoveIcon: false
        }}
        accept=".pdf"
      >
        <Button icon={<UploadOutlined />} size="middle">
          {t('work_post_sheet_form.newPdfCommentAttachment.upload_button')}
        </Button>
      </Upload>
    </Form.Item>
  )
}
